"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isErrorType = void 0;
function isErrorType(aggStatusString) {
    const acceptable = ['NEW', 'OK', 'MFA_CHALLENGE_READY_FOR_USER', 'DISCOVERED_ACCOUNTS_READY_FOR_USER', 'NO_ACCOUNTS_REFRESHED'];
    return !acceptable.includes(aggStatusString);
}
exports.isErrorType = isErrorType;
